// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lVir","footer":"styles_footer__ygYXk"};